export default "__VITE_ASSET__BEm1p1PG__"